import {configureStore} from '@reduxjs/toolkit';
import counterReducer from '../actions/counterSlice';
import scoreReducer from '../actions/scoreSlice';
import leaderboardReducer from '../actions/leaderboardSlice';
import userReducer from '../actions/userSlice';
import notificationsReducer from '../actions/notificationsSlice';
import {TypedUseSelectorHook, useSelector} from "react-redux";

export const store = configureStore({
    reducer: {
        counter: counterReducer,
        score: scoreReducer,
        leaderboard: leaderboardReducer,
        user: userReducer,
        notifications: notificationsReducer
    },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
